import utils from "../../../utils/utils.js";

export default {

  async fetchWorkspaceFeedIsSendPrivate(context) {
    const response = await utils.utility.fetch(
      `api/Setting/GetWorkspaceFeedIsSendPrivate`,
      "GET",
      null,
      null
    );
    context.commit("setWorkspaceFeedIsSendPrivate", response.data);
  },

  async changeEngagementFeedIsSendPrivate(context, payload) {
    let postData = { isSend: payload.isSendPrivate };
    await utils.utility.fetch(
      `api/Setting/ChangeEngagementFeedIsSendPrivate`,
      "POST",
      null,
      postData
    );
    context.commit("setWorkspaceFeedIsSendPrivate", payload.isSendPrivate);
  },
};
